import React from "react";
import { Field } from "formik";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";
import { convertTextToTitleCase } from "../../CommonFuntion/SchemaValidation";
import { applyMaskOnBlur } from "../../CommonFuntion/applyMaskOnBlur";

const TableMultiLineInputComponent = ({
  element,
  tableName,
  tdkeys,
  name,
  values,
  setFieldValue,
  error,
  errorBorder,
  id,
  rowkeys,
  disabled,
}) => {
  const textboxChange = (e) => {
    const { value } = e.target;
    const name2 = `${tableName}[${tdkeys}].${name}`;
    if (element.validation.characterCase) {
      switch (element.validation.characterCase) {
        case "U":
          setFieldValue(name2, value.toUpperCase());
          break;
        case "L":
          setFieldValue(name2, value.toLowerCase());
          break;
        case "C":
          setFieldValue(name2, convertTextToTitleCase(value));
          break;
        default:
          setFieldValue(name2, value);
          break;
      }
    } else {
      setFieldValue(name2, value);
    }
  };

  const textboxBlur = (e) => {
    if (!element.validation?.pictureMask) return;
    const name2 = `${tableName}[${tdkeys}].${name}`;
    const { nextValue, applied } = applyMaskOnBlur(
      e.target.value,
      element.validation.pictureMask
    );
    if (applied) {
      setFieldValue(name2, nextValue);
    }
  };

  return (
    <div className="wrapper">
      <div>
        <Field
          maxLength={
            element.validation?.pictureMask
              ? element.validation?.pictureMask.replace(/"/g, "").length
              : ""
          }
          title={
            (element.validation?.pictureMask
              ? "Picture Mask:" +
                element.validation?.pictureMask.replace(/"/g, "")
              : "") + (element.validation?.mandatory ? "\nMandatory" : "")
          }
          as="textarea"
          className={`tableInput ${errorBorder}`}
          id={id + tdkeys + 1}
          rowkeys={tdkeys}
          tdkeys={rowkeys}
          name={`${tableName}[${tdkeys}].${name}`}
          onChange={textboxChange}
          onBlur={textboxBlur}
          data-testid="TableMultiLineInputComponent"
          disabled={disabled}
        />
        {error?.[name] && (
          <span className="icon">
            <Tooltip title={error?.[name]}>
              <WarningIcon sx={{ color: pink[500] }} />
            </Tooltip>
          </span>
        )}
      </div>
    </div>
  );
};

export default TableMultiLineInputComponent;
